import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    isLoading: false,
    status: "",
    message:"",
    showUpdatePassForm: false,
    email: "",
    successupdate:""
   
}

const passwordReset = createSlice({
    name: "passwordReset",
    initialState,
    reducers:{
        otpReqPending: (state) => {
            state.isLoading = true;
        },
        otpReqSuccess: (state, { payload }) => {
            state.isLoading = false;
            state.status = "success";
            state.message = "6 digit otp sent to your email";
            state.email = payload.email;
            state.showUpdatePassForm = true;
            console.log(payload);
          },
          
        otpReqFail: (state,{payload}) => {
            state.isLoading = false;
            state.status = "error";
            state.message = "email must be valid email"; 
            console.log(payload)
        },
        updatePassPending: (state) => {
            state.isLoading = true;
        },
        updatePassSuccess: (state, { payload } ) => {
            state.isLoading= false;
            state.status="success";
            state.message= "password successfully updated";
            state.successupdate="success";
            //state.showUpdatePassForm=false;
        },
        updatePassFail:(state,{payload})=>{
            state.isLoading= false;
            state.status="error";
            state.message= "Please fill all the fields correctly";
            state.successupdate="fail";
            console.log(payload);

        }
        
    },
});

const {reducer, actions} = passwordReset;

export const {
    otpReqPending, 
    otpReqSuccess, 
    otpReqFail,
    updatePassSuccess,
    updatePassPending,
    updatePassFail

} = actions;
export default reducer;